import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';

import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { StorageEnum } from '../../enums/storage.enum';
import { ErrorData } from '../../models/error-data';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-error-page',
  imports: [MatDividerModule, MatButtonModule],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
})
export class ErrorPageComponent implements OnInit {
  pageReady = false;
  isAutopay = false;
  data: ErrorData = new ErrorData();
  isBrowser = false;

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly router: Router,
    // eslint-disable-next-line @typescript-eslint/prefer-readonly
    private storage: StorageService,
    // eslint-disable-next-line @typescript-eslint/prefer-readonly
    private utils: UtilService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.data = this.storage.getSession(StorageEnum.ErrorData);
      this.utils.hideSpinner();
    }
  }

  async goToRedirectPage(): Promise<void> {
    await this.router.navigateByUrl(this.data.CtaButton.Link);
  }

  async nav(link: string): Promise<void> {
    await this.router.navigateByUrl(link);
  }
}
